import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface TaskList {
  id: number,
  name: string
}
export interface Tasks {
  id: number,
  technology: string,
  notepadmode: string,
  name: string,
  information: string,
  result: string,
  resultsec: string,
  resulttype: string
}

@Injectable({
  providedIn: 'root'
})
export class TaskListService {

  constructor(private http: HttpClient) { }
  
  
  getAll(id: string) {
    return this.http.get<Tasks[]>(environment.api_url + 'api/v1.0/tasks/'+ id +'/lesson');
  }
  getTaskFields(id: string) {
    return this.http.get<any>(environment.api_url + 'api/v1.0/fields/'+id+'/task');
  }

  EditField(id: string, body) {
    return this.http.patch(environment.api_url + 'api/v1.0/fields/' + id, body);
  }
  AddField(id, body) {
    return this.http.post<any>(environment.api_url + 'api/v1.0/fields/'+id+'/task', body)
  }
  DeleteField(id) {
    return this.http.delete<any>(environment.api_url + 'api/v1.0/fields/'+id)
  }

  EditTask(id: string, body) {
    return this.http.patch<Tasks>(environment.api_url + 'api/v1.0/tasks/' + id, body);
  }
  DeleteTask(id: string) {
    return this.http.delete(environment.api_url + 'api/v1.0/tasks/'+id)
  }
  AddTask(id: string, body) {
    return this.http.post<Tasks>(environment.api_url + 'api/v1.0/tasks/' + id + '/lesson', body);
  }

}
